var $name="video/config",$path="app/modules/video/config.js",$this={$name,$path,};export const playerTypeDataAttr = 'player';
export const youtubeMarker = 'youtube';
export const youkuMarker = 'youku';

export const modalWrapOverlayClassName = 'wrap-modal-overlay';
export const modalWrapSelector = '.modal-wrap';
export const modalBtnCloseSelector = '.modal-close-btn';
export const modalBtnExpandSelector = '.modal-expand-btn';
export const embeddedPlayerNodeSelector = 'div[data-videolink]';
export const iframeYouTubeSelector = '.video-youtube-iframe';
export const iframeYoukuSelector = '.video-youku-iframe';
